import { GetApplicationResponse } from '@iwoca/lapi-client/edge';

import {
  isLoanDurationValueUK,
  isLoanPurposeValueUK,
  TLoanFieldsDataUK,
} from './loanOptions';
import { normaliseLoanDurationToMonths } from '../helpers/stateNormalisation';

export const getLoanFieldsFromApplicationUK = (
  application?: GetApplicationResponse['data'],
): TLoanFieldsDataUK => {
  const requestedProduct = application?.requested_products?.[0];

  const loanDuration = requestedProduct?.duration
    ? normaliseLoanDurationToMonths(requestedProduct.duration)
    : undefined;

  return {
    amount: requestedProduct?.amount?.toString(),
    loanDuration: isLoanDurationValueUK(loanDuration)
      ? loanDuration
      : undefined,
    loanPurpose: isLoanPurposeValueUK(requestedProduct?.purpose)
      ? requestedProduct.purpose
      : undefined,
  };
};
